import CommonText from 'common/components/entities/TextNew/ui/TextUi'
import React, { ComponentProps } from 'react'
import type {
  WebsiteThemeInterface,
  WebsiteTypographySettingsStylesInterface,
} from 'src/shared/types/website-settings-types'

export interface PublicPageHeadingProps
  extends Omit<ComponentProps<typeof CommonText>, 'textAlign'> {
  heading?: WebsiteTypographySettingsStylesInterface
  theme?: WebsiteThemeInterface
}

export const PublicPageHeading: React.FC<PublicPageHeadingProps> = ({
  heading,
  theme,
  style,
  children,
}) => {
  return (
    <CommonText
      as="h1"
      color={theme?.text.headingTextColor}
      backgroundColor={theme?.text.headingBackgroundColor}
      fontFamily={heading?.fontFamily}
      fontSize={heading?.fontSize}
      lineHeight={heading?.lineHeight}
      letterSpacing={heading?.letterSpacing}
      fontStyle={heading?.fontStyle}
      fontWeight={heading?.fontWeight}
      textAlign="center"
      mobileFontFamily={heading?.mobileFontFamily}
      mobileFontSize={heading?.mobileFontSize}
      mobileLineHeight={heading?.mobileLineHeight}
      mobileLetterSpacing={heading?.mobileLetterSpacing}
      mobileFontStyle={heading?.mobileFontStyle}
      mobileFontWeight={heading?.mobileFontWeight}
      style={style}
    >
      {children}
    </CommonText>
  )
}
